import {
	PAID_PLANS as CANONICAL_PAID_PLANS,
	normalizePlanId,
} from './entitlements'

export function isPaidPlan(planId?: string | null) {
	return CANONICAL_PAID_PLANS.includes(normalizePlanId(planId))
}

export function hasUnlimitedCoreLimits(planId?: string | null) {
	return false
}

export function supportsOverageBilling(planId?: string | null) {
	return isPaidPlan(planId)
}
